<template>
  <div class="news_list_wrap">
    <div class="jz_empty_tips u-box">
      <i class="jz_empty_tips__img"></i>
      <div v-if="selectType === 'label'">{{$t('widgets_basic_article_list_index_416')}}</div>
      <!-- class="jz_empty_tips__text" -->
      <div  v-else>{{$t('components_selection_prompt_index_2460', [btnText])}}</div>
      <div class="jz_empty_tips__buttons u-btn-gp" v-if="selectType !== 'label'">
        <template v-if="action == 'list'">
          <template v-if="type !== 'recommendList'">
            <el-button size="small" @click="add_content" type="primary">{{$t('components_selection_prompt_index_2461', [btnText])}}</el-button>
            <my_add_button :type="type" :selectIds="ids" @confirm="select" ></my_add_button>
          </template>

        </template>
        <template v-else>
          <el-button size="small" @click="select_class" type="primary">{{$t('widgets_basic_article_classification_index_339')}}</el-button>
          <el-button size="small" @click="manage_class">{{$t('widgets_basic_article_classification_edit_320')}}</el-button>
        </template>
      </div>
    </div>
    <basic_management :typeTag="typeTag" :showTag.sync="showTag" v-if="showTag"></basic_management>
  </div>
</template>

<script type="text/javascript">
import i18n from '../../language/index'

// if (this.type === 'goodsList') {
//         text = '选择产品'
//       }
//       if (this.type === 'albumList') {
//         text = '选择图册'
//       }
//       if (this.type === 'articleList') {
//         text = '选择文章'
//       }
//       if (this.type === 'testList') {
//         text = '选择测试数据'
//       }
export default {
  name: "app",
  data() {
    return {
      list: this.ids,
      showTag:false,
      btnText:'',
      typeTag:0
    };
  },
  props: {
    ids: {
      type: Array,
      default: function() {
        return [];
      }
    },
    type: {
      type: String,
      default: ""
    },
    //是操作列表，还是操作分类
    action: {
      type: String,
      default: "list"
    },
    selectType: { // 标签添加传递的一个参数
      type: String,
      default: ''
    }
  },
  watch: {
    list(val) {
      this.$emit("update:ids", val);
    }
  },
  methods: {
    select(val) {
      this.list = val;
    },
    add_content() {
      this.$emit("add_content");
    },
    select_class(){
      this.$emit("select_class");
    },
    manage_class(){
      this.showTag = true;
    },
    data_init(){
      if (this.type === "goodsList") {
        this.btnText = i18n.t('widgets_basic_classification_edit_482');
        this.typeTag = 0;
      }
      else if (this.type === "albumList") {
         this.btnText = i18n.t('components_basic_addarticle_index_2010');
         this.typeTag = 5;
      }
      else if (this.type === "articleList") {
        this.btnText = i18n.t('widgets_basic_article_classification_edit_333');
        this.typeTag = 1;
      }
      if(this.type === 'recommendList') {
        this.btnText = i18n.t('widgets_basic_floating_frame_edit_529')
      }

    }
  },
  computed: {

  },
  created() {
    this.data_init();
  },
  mounted() {},
  components: {}
};
</script>

<style lang="scss" scoped>
.news_list_wrap {
  .jz_empty_tips {
    width: 100%;
    padding: 90px 0;
    text-align: center;
  }
  .jz_empty_tips__img {
    display: block;
    width: 157px;
    height: 123px;
    margin: 0 auto;
    /*background: url(/image/rimage/jz/defaultIcon.png?v=201811211412) 0 0;*/
  }
  .jz_empty_tips__text {
    margin-top: 28px;
    font-size: 16px;
    line-height: 24px;
    color: #333;
  }
  .jz_empty_tips__buttons {
    margin-top: 20px;
  }
  .jz_button__active {
    background-color: #5874d8;
    border-color: #5874d8;
    color: #fff;
    outline: 0;
  }
  .jz_button {
    display: inline-block;
    position: relative;
    box-sizing: border-box;
    height: 34px;
    padding: 0 13px;
    border: 1px solid #e3e2e8;
    cursor: pointer;
    user-select: none;
    border-radius: 2px;
    background-color: #fff;
    outline: 0;
    font-size: 13px;
    font-weight: 400;
    line-height: 0;
    color: #333;
    white-space: nowrap;
  }
  .jz_empty_tips__button {
    margin: 0 15px;
  }
  .u-box {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .u-btn-gp {
    display: flex;
    width: 200px;
    justify-content: space-between;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/selection_prompt/index.vue